const Router = require("vue-router")
const onestoreutils = require("onestore-utils");
const axios = require("axios")
const auth = require("./auth")
const logger = require("@/utils/logger");

//import Auth0Lock from "auth0-lock";

const config = require("config");

function AppAuthorization() {
  var self = {}

  self.listenToCrossWindowsPostMessages = function (callback) {
    if (self.isListening) return
    self.isListening = true
    logger.log('Starting listening to post messages...')

    var qs = onestoreutils.parsehashBangQueryStringParams()
    var opener_window_origin = qs.opener_window_origin;
    var xdomain_message_id = qs.xdomain_message_id;

    window.addEventListener("message", function (event) {
      self.onPostMessageReceived(callback, event, opener_window_origin, xdomain_message_id);
    }, false);
  }

  self.onPostMessageReceived = function (callback, event, opener_window_origin, xdomain_message_id) {
    if (self.gotToken) return
    logger.log('Received event from ' + event.origin, event);

    if (!(event.data.origin) || !(event.data.xdomain_message_id)) {
      logger.log('self message is not for us');
      return;
    }
    if (event.data.origin != opener_window_origin || event.data.xdomain_message_id != xdomain_message_id) {
      logger.log('Event rejected.');
      return;
    }
    self.gotToken = true
    self.setTokenRequest(event.data.token_request)
    logger.log('Token request received: ' + self.getTokenRequest())
    callback()
  }

  self.setTokenRequest = function (t) {
    localStorage.setItem('_onestore_token_request_', t)
  }
  self.getTokenRequest = function (t) {
    return localStorage.getItem('_onestore_token_request_')
  }

  self.authorize = function (namespace, expiration, onError) {
    auth.requireAuthRedirect();
    const url = config.restAPIURL + '/auth/authorize-app';

    return axios
      .post(url, {
        token_request: self.getTokenRequest(),
        namespace: namespace,
        expiration: expiration
      }, {
        headers: auth.getHeaders()
      })
      .then(response => {
        logger.log('Authorization successful.')
        window.close()
      })
      .catch(err => {
        console.error(err)
        onError('Failed to generate token.')
      })
  }

  this.updateResultPage = function (success) {
    this.updateUIVariableContainers('namespace', this.namespace);
    this.updateUIVariableContainers('email', this.email);

    const status = success ? 'successful' : 'failed';
    this.updateUIVariableContainers('callback_result_message', 'Authorization ' + status + ' for namespace ' + this.namespace + ' by user ' + this.email + '.');

    document.getElementById('callback_result_image').src = success ? 'images/success.svg' : 'images/failure.svg';

    if (success) this.updateUIVariableContainers('callback_result_extra', 'This window will close in a moment...');
  }

  return self
}

module.exports = AppAuthorization()



// WEBPACK FOOTER //
// ./src/utils/app-authorization.js